module.exports = __webpack_public_path__ + "img/content-planner.971ed19a.png";